import { render, staticRenderFns } from "./edutalk-header.vue?vue&type=template&id=d330a546"
import script from "./edutalk-header.vue?vue&type=script&lang=js"
export * from "./edutalk-header.vue?vue&type=script&lang=js"
import style0 from "./edutalk-header.vue?vue&type=style&index=0&id=d330a546&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports